export const SET_DARK_MODE = 'SET_DARK_MODE'
export const SET_LANGUAGE = 'SET_LANGUAGE'
